import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { createUpdateQueryCallback } from 'automation-ui-log-events/components/execution-results/utils/createUpdateQueryCallback';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadMoreButton = ({
  loading,
  fetchMore,
  nextPage,
  fieldName
}) => {
  const showPaging = loading || !!nextPage;
  if (showPaging) {
    return /*#__PURE__*/_jsx("div", {
      className: "m-bottom-3",
      style: {
        textAlign: 'center',
        paddingTop: '10px'
      },
      children: /*#__PURE__*/_jsx(UIButton
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      , {
        onClick: () => {
          return fetchMore({
            variables: {
              nextPage
            },
            updateQuery: createUpdateQueryCallback(fieldName)
          });
        },
        disabled: loading,
        use: "tertiary-light",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-log-events.logEventExecutionResultsTable.loadMore"
        })
      })
    });
  }
  return null;
};
export default LoadMoreButton;